var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 810,
    height: 700,
    viewBox: "0 0 810 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.36 503.045C180.957 490.111 172.577 477.52 159.643 474.924C146.709 472.327 134.119 480.707 131.522 493.641C128.925 506.575 137.305 519.165 150.239 521.762C163.173 524.359 175.763 515.979 178.36 503.045Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.452 484.287C170.338 485.618 170.784 487.194 170.728 488.792C170.672 490.39 170.117 491.93 169.14 493.196L162.249 502.099L153.869 512.947C152.624 514.531 150.805 515.558 148.806 515.806C146.808 516.054 144.792 515.502 143.199 514.27C141.606 513.038 140.565 511.226 140.301 509.23C140.038 507.233 140.575 505.214 141.794 503.611L149.416 493.773L157.085 483.904C157.826 482.948 158.783 482.181 159.878 481.667C160.973 481.153 162.175 480.906 163.384 480.947C164.593 480.988 165.775 481.316 166.833 481.903C167.89 482.49 168.793 483.32 169.468 484.325L169.452 484.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.453 484.287C170.338 485.618 170.785 487.194 170.728 488.792C170.672 490.39 170.117 491.93 169.14 493.196L162.249 502.099C159.099 497.881 154.547 494.926 149.412 493.766L157.081 483.897C157.822 482.941 158.779 482.174 159.874 481.66C160.969 481.146 162.171 480.9 163.38 480.941C164.589 480.982 165.771 481.309 166.829 481.897C167.886 482.484 168.789 483.314 169.464 484.318L169.453 484.287Z",
    fill: "#38B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.452 484.287C170.338 485.618 170.784 487.194 170.728 488.792C170.672 490.39 170.117 491.93 169.14 493.196L162.249 502.099L153.869 512.947C152.624 514.531 150.805 515.558 148.806 515.806C146.808 516.054 144.792 515.502 143.199 514.27C141.606 513.038 140.565 511.226 140.301 509.23C140.038 507.233 140.575 505.214 141.794 503.611L149.416 493.773L157.085 483.904C157.826 482.948 158.783 482.181 159.878 481.667C160.973 481.153 162.175 480.906 163.384 480.947C164.593 480.988 165.775 481.316 166.833 481.903C167.89 482.49 168.793 483.32 169.468 484.325L169.452 484.287Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.249 502.1C159.129 497.85 154.564 494.887 149.412 493.766",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.748 483.332C166.633 483.757 167.379 484.422 167.903 485.252",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.563 493.06L158.73 485.144C159.278 484.427 159.979 483.841 160.781 483.427C161.584 483.013 162.468 482.783 163.37 482.751",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.188 126.19C404.452 115.179 401.414 100.363 390.402 93.0983C379.391 85.8338 364.575 88.8716 357.31 99.8835C350.046 110.895 353.084 125.711 364.095 132.976C375.107 140.24 389.923 137.202 397.188 126.19Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.646 116.796L368.44 122.534C366.676 123.009 364.794 122.764 363.21 121.852C361.626 120.941 360.469 119.438 359.993 117.674C359.518 115.909 359.763 114.028 360.674 112.444C361.585 110.86 363.088 109.703 364.853 109.226L386.054 103.482C387.819 103.009 389.699 103.255 391.282 104.166C392.866 105.077 394.023 106.579 394.502 108.342C394.977 110.107 394.732 111.988 393.822 113.573C392.912 115.158 391.41 116.317 389.646 116.796Z",
    fill: "#38B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.769 118.986L371.055 110.111",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.439 115.802L382.725 106.956",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.438 117.8C375.763 117.584 375.851 117.145 375.635 116.821C375.419 116.496 374.98 116.408 374.656 116.624C374.331 116.84 374.243 117.279 374.459 117.603C374.675 117.928 375.113 118.016 375.438 117.8Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.977 115.096C382.055 115.212 382.096 115.349 382.096 115.489C382.095 115.628 382.054 115.765 381.976 115.881C381.898 115.997 381.788 116.087 381.659 116.14C381.53 116.193 381.388 116.207 381.251 116.18C381.114 116.152 380.988 116.085 380.889 115.986C380.791 115.887 380.724 115.761 380.697 115.624C380.67 115.487 380.684 115.345 380.738 115.216C380.791 115.087 380.882 114.977 380.998 114.9C381.154 114.796 381.345 114.758 381.529 114.795C381.712 114.832 381.874 114.94 381.977 115.096Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.235 111.053C374.56 110.837 374.648 110.399 374.432 110.074C374.216 109.749 373.778 109.661 373.453 109.877C373.128 110.093 373.04 110.532 373.256 110.856C373.472 111.181 373.911 111.269 374.235 111.053Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.653 108.354C380.731 108.47 380.772 108.606 380.771 108.746C380.771 108.886 380.73 109.022 380.652 109.138C380.574 109.254 380.464 109.344 380.334 109.398C380.205 109.451 380.063 109.464 379.926 109.437C379.789 109.41 379.664 109.342 379.565 109.243C379.467 109.144 379.4 109.018 379.373 108.881C379.346 108.744 379.36 108.602 379.414 108.473C379.467 108.344 379.558 108.234 379.674 108.157C379.83 108.053 380.021 108.016 380.204 108.053C380.388 108.089 380.549 108.198 380.653 108.354Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.646 116.796L368.44 122.534C366.676 123.009 364.794 122.764 363.21 121.852C361.626 120.941 360.469 119.438 359.993 117.674C359.518 115.909 359.763 114.028 360.674 112.444C361.585 110.86 363.088 109.703 364.853 109.226L386.054 103.482C387.819 103.009 389.699 103.255 391.282 104.166C392.866 105.077 394.023 106.579 394.502 108.342C394.977 110.107 394.732 111.988 393.822 113.573C392.912 115.158 391.41 116.317 389.646 116.796Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.745 256.921C153.105 261.534 166.863 255.254 171.476 242.894C176.089 230.535 169.809 216.776 157.45 212.163C145.09 207.551 131.331 213.831 126.719 226.19C122.106 238.549 128.386 252.308 140.745 256.921Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.705 239.899L158.282 249.071C157.414 251.397 155.223 252.73 153.402 252.051L134.375 244.949C132.547 244.267 131.772 241.827 132.64 239.501L136.063 230.329C136.931 228.003 139.122 226.67 140.943 227.35L144.072 228.518L146.058 223.196L158.693 227.912L156.707 233.233L159.948 234.443C161.791 235.13 162.573 237.573 161.705 239.899Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.303 240.952L135.669 231.385L133.547 237.071L159.181 246.638L161.303 240.952Z",
    fill: "#38B17B",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.13 217.62L159.524 221.126C160.584 221.522 161.444 222.322 161.914 223.352C162.384 224.382 162.426 225.556 162.03 226.617L160.48 230.771L143.081 224.278L144.631 220.123C144.827 219.597 145.125 219.116 145.508 218.705C145.891 218.295 146.351 217.964 146.861 217.731C147.372 217.499 147.923 217.369 148.484 217.35C149.045 217.331 149.604 217.422 150.13 217.62Z",
    fill: "#38B17B",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.069 217.512L146.12 225.412",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.273 218.793L150.231 226.946",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.383 220.327L154.34 228.48",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.321 222.322L158.45 230.014",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.546 529.088C411.109 517.068 396.958 511.731 384.938 517.168C372.918 522.605 367.581 536.756 373.018 548.776C378.455 560.795 392.606 566.132 404.626 560.696C416.645 555.259 421.982 541.108 416.546 529.088Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.283 537.348C407.4 531.326 400.461 527.357 392.784 528.482C385.107 529.607 379.598 535.401 380.481 541.422C381.363 547.443 388.302 551.413 395.98 550.288C403.657 549.162 409.165 543.369 408.283 537.348Z",
    fill: "#38B17B",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.968 535.31C407.14 529.661 400.246 525.994 392.568 527.119C384.891 528.244 379.338 533.735 380.166 539.384C380.994 545.032 387.889 548.699 395.566 547.574C403.243 546.449 408.796 540.958 407.968 535.31Z",
    fill: "#38B17B",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.527 529.223L393.065 544.178",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.087 530.471C389.142 529.957 390.242 529.544 391.373 529.237",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.035 544.295C388.035 544.295 381.664 542.713 382.675 536.427C382.942 535.028 383.653 533.752 384.704 532.79",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.742 440.067C631.876 427.049 623.053 414.765 610.034 412.631C597.016 410.497 584.732 419.32 582.598 432.339C580.464 445.357 589.287 457.641 602.306 459.775C615.324 461.909 627.608 453.086 629.742 440.067Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.879 438.597C619.697 438.859 619.514 439.129 619.324 439.391C615.746 444.349 610.233 448.974 606.147 449.886L606.147 449.823C602.18 448.934 596.842 444.531 593.264 439.724C593.065 439.462 592.875 439.192 592.693 438.931C589.25 433.996 587.798 428.816 591.629 426.674C599.42 422.327 606.147 431.648 606.147 431.648C606.147 431.648 612.89 422.398 620.665 426.737C624.393 428.816 623.116 433.782 619.879 438.597Z",
    fill: "#38B17B",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.879 438.597C619.697 438.859 619.514 439.129 619.324 439.391L617.356 439.391L615.103 442.366L613.572 433.544L611.192 439.541L605.568 439.541L602.688 444.341L600.467 434.623L597.603 439.692L593.264 439.692C593.065 439.43 592.875 439.161 592.692 438.899L597.143 438.899L600.784 432.449L603.021 442.247L605.139 438.716L610.693 438.716L613.866 430.593L615.563 440.398L616.952 438.566L619.879 438.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.234 195.279C672.216 187.969 675.193 173.141 667.883 162.159C660.574 151.177 645.746 148.2 634.764 155.509C623.782 162.819 620.804 177.647 628.114 188.629C635.423 199.611 650.252 202.588 661.234 195.279Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.387 167.195C640.865 167.496 640.302 169.243 639.161 171.079C638.02 172.916 636.659 174.193 636.178 173.885C635.696 173.576 636.256 171.841 637.404 170C638.552 168.159 639.917 166.917 640.387 167.195Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.613 179.684L657.579 186.523L644.929 179.086L636.189 173.944L640.218 167.098L648.743 172.116L661.613 179.684Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.799 175.475L640.586 172.561L638.799 175.475Z",
    fill: "#38B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.799 175.475L640.586 172.561",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.513 177.119L643.3 174.205L641.513 177.119Z",
    fill: "#38B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.513 177.119L643.3 174.205",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.123 183.904L664.875 185.889L660.165 182.134L659.123 183.904Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.613 179.684C661.148 182.005 660.001 184.136 658.319 185.802L657.579 186.523L644.929 179.086L648.743 172.116L661.613 179.684Z",
    fill: "#38B17B",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.44 180.426L649.123 177.685",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.475 182.093L652.134 179.417L650.475 182.093Z",
    fill: "#38B17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.475 182.093L652.134 179.417",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.581 171.569L632.881 168.588L633.803 166.765L638.683 169.702L637.581 171.569Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.092 163.832L635.983 163.141L630.419 171.962L631.527 172.653C631.994 172.953 633.608 171.212 635.15 168.775C636.692 166.338 637.554 164.125 637.092 163.832Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.984 163.141C635.522 162.848 633.897 164.587 632.361 167.019C630.826 169.452 629.957 171.669 630.419 171.962C630.881 172.255 632.506 170.516 634.037 168.077C635.568 165.638 636.445 163.434 635.984 163.141Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/Medicine.a3543a6345d85b500a3cdf3e1c3d56c6.svg";
export { ForwardRef as ReactComponent };